export default function PHP_is_readable() {
  return (
    <div>
      <h1>PHP_is_readable</h1>
    </div>
  );
}
